// extracted by mini-css-extract-plugin
export var quiz = "style-module--quiz--26cl0";
export var quiz_img = "style-module--quiz_img--3gqwE";
export var quiz_img_elem = "style-module--quiz_img_elem--1BUo-";
export var quiz_img_phone = "style-module--quiz_img_phone--3Xas2";
export var quiz_form = "style-module--quiz_form--1yni8";